var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ABreadcrumbV1',{attrs:{"items":_vm.breadcrumbs}}),_c('v-row',{staticClass:"mb-3"},[_c('v-col',[_c('h1',[_vm._v(_vm._s(_vm.$t("model.name.finishers")))])])],1),_c('List')],1)}
var staticRenderFns = []

export { render, staticRenderFns }